export default {
  props: ["text", "tooltip", "maxlength", "required", "email", "items", "disabled", "label", "cellid", "editingcell", "readonly", "translate", "autofocus", "password", "decimals"],
  data() {
    return {};
  },
  computed: {
    editing() {
      return !this.readonly && this.cellid === this.editingcell;
    },
    hasTooltip() {
      return !!this.tooltip;
    },
    trxtext() {
      if (this.translate) {
        let trx = `${this.translate}.${this.text}`;
        this.$log.debug("trx:", trx);
        if (this.$i18n.te(trx)) return this.$i18n.t(trx);
        this.$log.debug("trx:nope");
      }
      return this.text;
    },
  },
  watch: {
    editingcell() {
      if (this.cellid === this.editingcell) this.startEdit();
    },
  },
  methods: {
    blur() {
      this.$emit("blur");
    },
    startEdit() {
      this.$nextTick(() => {
        this.$log.debug("STARTEDIT: focus(" + this.cellid + ")");
        this.$log.debug("STARTEDIT-1.1: " + !this.readonly);
        this.$log.debug("STARTEDIT-1.2: " + this.cellid);
        this.$log.debug("STARTEDIT-1.3: " + this.editingcell);
        this.$log.debug("STARTEDIT-1.4: " + (this.cellid === this.editingcell));
        this.$log.debug("STARTEDIT-1: " + this.editing);
        this.$log.debug("STARTEDIT-2: " + this.readonly);
        if (this.editing && this.$refs && this.$refs.atinput && this.$refs.atinput.focus) {
          this.$refs.atinput.focus();
          this.$log.debug("STARTEDIT: INNER");
        }
      });
    },
    changed(text) {
      this.$log.debug(text);
      this.$emit("change", text);
    },
  },
};
